import { Component, isDevMode, OnInit } from '@angular/core';
import { StompService } from '@stomp/ng2-stompjs';
import { ToasterConfig, ToasterService } from 'angular2-toaster';
import { Globals } from '../../globals';
import { SftpDataCryptoService } from '../../service-crypto/sftp-data-crypto.service';

export interface IWebSocketServerMessage {
  title: string;
  message: string;
  severity: string;
}

@Component({
  selector: 'crypto-async-push',
  templateUrl: './async-push-crypto.component.html',
  styleUrls: [ './async-push-crypto.component.scss' ],
})
export class AsyncPushCryptoComponent implements OnInit {
  ws: any;
  config: ToasterConfig;

  constructor(private globals: Globals, private toasterService: ToasterService, private sftpDataCryptoService: SftpDataCryptoService, private stompService: StompService) {
    this.config = globals.config;
  }

  ngOnInit() {
    this.connect();
  }

  connect() {
    const that = this;
    const errors = this.stompService.subscribe('/errors');
    errors.subscribe(function errorsFunction(message) {
      if (isDevMode()) {
        console.log('STOMP error=' + JSON.stringify(message.body));
      }
      const parsedMessage = JSON.parse(message.body);
      const type = that.globals.getToast(parsedMessage.severity, parsedMessage.title, parsedMessage.message);
      type.timeout = 0; // never close
      that.toasterService.popAsync(type);
    }, (error) => {
      if (isDevMode()) {
        console.log('STOMP error communication error=' + JSON.stringify(error));
      }
      const type = that.globals.getToast('error', 'Server communication error', error);
      that.toasterService.popAsync(type);
    });
    const queue = this.stompService.subscribe('/queue');
    queue.subscribe(function queueFunction(message) {
      if (isDevMode()) {
        console.log('STOMP message=' + message.body);
      }
      const parsedMessage = JSON.parse(message.body);
      const type = that.globals.getToast(parsedMessage.severity, parsedMessage.title, parsedMessage.message);
      that.toasterService.popAsync(type);
    }, (error) => {
      if (isDevMode()) {
        console.log('STOMP message communication error=' + JSON.stringify(error));
      }
      const type = that.globals.getToast('error', 'Server communication error', error);
      that.toasterService.popAsync(type);
    });
    const queueData = this.stompService.subscribe('/queue-data');
    queueData.subscribe(function queueDataFunction(data) {
      if (isDevMode()) {
        console.log('STOMP data=' + data.body);
      }
      that.sftpDataCryptoService.updateData(JSON.parse(data.body).data);
    }, (error) => {
      if (isDevMode()) {
        console.log('STOMP data communication error=' + JSON.stringify(error));
      }
      const type = that.globals.getToast('error', 'Server communication error', error);
      that.toasterService.popAsync(type);
    });
    const keepalive = this.stompService.subscribe('/keepalive');
    keepalive.subscribe(function queueDataFunction(data) {
      if (isDevMode()) {
        console.log('STOMP keepalive=' + data.body);
      }
    }, (error) => {
      if (isDevMode()) {
        console.log('STOMP keepalive communication error=' + JSON.stringify(error));
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/pages-crypto/components-crypto/async-push-crypto/async-push-crypto.component.ts